module.exports = __webpack_public_path__ + "47fb199ace717bc222f991b31cd718bb.svg";